/**
 * Created by anatolij on 29.09.2026
 */

const RoyalLeagueStartWindow = Prefab.createWindow(
    "royal_league_start_window",
    "royal_league_start_window_prefab_json"
);
